import { useState, useEffect } from 'react';

interface RegistroExitoProps {
  nombre: string;
  folio: string;
  fechaCobertura: string;
  onEntrar: () => void;
}

export default function RegistroExito({ nombre, folio, fechaCobertura, onEntrar }: RegistroExitoProps) {
  const [checkVisible, setCheckVisible] = useState(false);
  const [contentVisible, setContentVisible] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setCheckVisible(true), 300);
    const t2 = setTimeout(() => setContentVisible(true), 800);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  const copyFolio = () => {
    navigator.clipboard.writeText(folio).catch(() => {});
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-5 py-12" style={{ backgroundColor: '#0d0520' }}>
      {/* Decorative background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 rounded-full opacity-5" style={{ background: 'radial-gradient(circle, #1D9E75, transparent)' }} />
      </div>

      {/* Checkmark animation */}
      <div
        className="w-24 h-24 rounded-full flex items-center justify-center mb-6 transition-all duration-600"
        style={{
          backgroundColor: checkVisible ? 'rgba(29,158,117,0.15)' : 'transparent',
          border: `3px solid ${checkVisible ? '#1D9E75' : 'transparent'}`,
          transform: checkVisible ? 'scale(1)' : 'scale(0)',
        }}
      >
        <i
          className="ri-check-line text-5xl transition-all duration-400"
          style={{ color: '#1D9E75', opacity: checkVisible ? 1 : 0 }}
        />
      </div>

      {/* Content */}
      <div
        className="flex flex-col items-center gap-5 w-full max-w-sm transition-all duration-500"
        style={{ opacity: contentVisible ? 1 : 0, transform: contentVisible ? 'translateY(0)' : 'translateY(20px)' }}
      >
        <div className="text-center">
          <h2 className="text-2xl font-bold text-white mb-1">¡Bienvenido, {nombre}!</h2>
          <p className="text-sm text-gray-400">Tu membresía ha sido activada</p>
        </div>

        {/* Folio */}
        <div className="w-full rounded-xl px-4 py-3 flex items-center justify-between" style={{ backgroundColor: '#1a1035' }}>
          <div>
            <p className="text-xs text-gray-500 mb-0.5">Número de folio</p>
            <span className="font-mono font-bold text-lg" style={{ color: '#AFA9EC' }}>{folio}</span>
          </div>
          <button
            onClick={copyFolio}
            className="w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer transition-colors"
            style={{ backgroundColor: copied ? 'rgba(29,158,117,0.2)' : 'rgba(175,169,236,0.1)' }}
          >
            <i className={`${copied ? 'ri-check-line text-green-400' : 'ri-file-copy-line'} text-base`} style={{ color: copied ? '#1D9E75' : '#AFA9EC' }} />
          </button>
        </div>

        {/* Carencia notice */}
        <div className="w-full rounded-xl px-4 py-3 border" style={{ backgroundColor: 'rgba(245,158,11,0.1)', borderColor: 'rgba(245,158,11,0.4)' }}>
          <div className="flex items-start gap-2">
            <i className="ri-time-line text-[#F59E0B] text-lg flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-xs font-semibold text-[#F59E0B] mb-0.5">Carencia de 90 días</p>
              <p className="text-xs text-amber-200/70 leading-relaxed">
                Cobertura completa activa el <strong className="text-[#F59E0B]">{fechaCobertura}</strong>. Durante este período tienes acceso a orientación médica.
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <button
          onClick={onEntrar}
          className="w-full py-4 rounded-full text-white font-bold text-base cursor-pointer whitespace-nowrap transition-transform active:scale-95 mt-2"
          style={{ backgroundColor: '#534AB7' }}
        >
          Ir a mi membresía →
        </button>
      </div>
    </div>
  );
}
